export const CLASS_POLL = 'poll';
export const POLL_DELAY_AFTER = 1000;
export const POLL_DELAY_AFTER_HOVER = 1500;
export const POLL_RATING_OPTIONS: string[] = Array.from({ length: 5 }, (a, i) => '');
